module.exports = "<div class=\"download-button {{$ctrl.additionalClasses}}\">\r\n   <a ng-click=\"$ctrl.callDownload()\"\r\n      ng-if=\"!$ctrl.showProgress\">{{$ctrl.title}}</a>\r\n   <div ng-click=\"$ctrl.cancelDownload()\"\r\n        ng-if=\"$ctrl.showProgress\">\r\n      <md-progress-linear md-mode=\"indeterminate\"></md-progress-linear>\r\n      <translate>Cancel download</translate>\r\n   </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/download-element/link/link.html
// module id = 1843
// module chunks = 0